export let routes = [
  {
    path: '/x3-side-comform',
    name: 'x3-side-comform',
    component: () => import('./comform.vue'),
    meta: {
      vx_animate: 'none',
    },
  }
];

export let api = {
  xsComForm(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-comform',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
